import React, { useState, useEffect } from "react";
import { Form, FormGroup, Input, Button, Row, Col, Label } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";
import { CircularProgress } from "../../../..";
import { AccountMode } from "../../../../utils/Helper";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalComments from "../ModalComments";
import style from "../Risk/styles.module.scss";
import PersonRiskTable from "../Risk/PersonRiskTable";

const FinalizeTab = ({
  Finalize,
  accountId,
  person,
  account,
  setAccountData,
  setPersonData,
  setRedirectPerson,
  services,
  mode,
  userType,
  onboarding,
  riskByPersonIsEnabled,
}) => {
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [personlist, setPersonList] = useState([]);
  const [showResults, setShow] = useState(false);
  const [listResults, setResults] = useState([]);
  const [reportId, setReportid] = useState(0);
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false,
    accountId: undefined,
  });

  const [personresult, setPersonResult] = useState({
    PersonRisk: "",
    PersonTransactionalLimit: "",
    PersonProfileRisk: "",
  });
  const now = new Date();

  const [modalComments, setModalComments] = useState({
    open: false,
    fromDate: new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()),
    toDate: now,
    personId: undefined,
    person: undefined,
  });

  const toggleModalComments = (e, person) => {
    setModalComments({
      ...modalComments,
      open: !modalComments.open,
      person: person,
    });
  };

  const handleCreatePerson = () => {
    setLoadingSave(true);
    const body = {
      onboardingProcessId: onboarding,
    };
    services.fetchCreateOnboardingPerson(body, (data) => {
      if (data && data.result) {
        if (data.result.Code === 200) {
          alert(data.result.Description);
          setRedirectPerson(data.id);
        } else {
          alert(`Failed! ${data.result.Description}`);
        }
      }
      setLoadingSave(false);
    });
  };

  const createOnboardingPerson = () => {
    setModalConfirm((m) => ({
      ...m,
      open: true,
      title: "Are you sure you want to send person information?",
      accountId,
      callback: () => handleCreatePerson(),
    }));
  };

  const listCheck = () => {
    setLoadingCheck(true);
    const body = {
      sdtApproveAccount: personlist,
      fromType: "EasyAccount",
    };
    if (personlist.length < 1) {
      alert("There aren't people to check!");
    } else {
      services.AccountListCheck(body, (data) => {
        if (data && data.error) {
          if (data.error.lenght > 0) {
            setResults(data.error);
          }
          setReportid(data.logListId);
        }
        setLoadingCheck(false);
      });
    }
  };

  useEffect(() => {
    setLoadingData(true);
    let personWithoutArchives = {
      ...person,
      Archives: person.Archives.map((a) => ({
        ...a,
        PersonArchivesBlob: "",
      })),
    };
    const body = {
      postPerson: personWithoutArchives,
      onboarding: onboarding,
    };

    services.fetchOnboardingPersonResult(body, (data) => {
      if (data && data.SDTOnboardingResult) {
        setLoadingData(false);
        setPersonResult({ ...data.SDTOnboardingResult });
        setPersonData({
          ...person,
          PersonProfileRiskName: data.SDTOnboardingResult.PersonProfileRisk,
          PersonRisk: data.SDTOnboardingResult.PersonRisk,
          PersonTransactionalLimit: data.SDTOnboardingResult.PersonTransactionalLimit,
        });
      } else {
        setLoadingData(false);
      }
    });
  }, []);

  const toggleModalConfirm = () =>
    setModalConfirm({
      open: false,
      title: "",
      accountId: undefined,
      callback: undefined,
      loading: false,
    });

  if (loadingData) {
    return <CircularProgress sm />;
  }
  return (
    <div>
      <Row>
        {personresult && personresult.AccountRiskSummary && (
          <PersonRiskTable person={person} riskSummary={personresult.AccountRiskSummary} riskByPersonIsEnabled={riskByPersonIsEnabled} onboarding={onboarding}/>
        )}
      </Row>
      <Row>
        <div></div>
      </Row>
      <Row>
        <Col>
          <LaddaButton
            style={{ marginLeft: 10, marginTop: 50 }}
            className="btn btn-ladda btn-primary"
            loading={loadingSave}
            onClick={(e) => toggleModalComments(e, person)}
            data-style={EXPAND_RIGHT}
          >
            Reject Person
          </LaddaButton>
        </Col>
        <Col>
          <LaddaButton
            style={{ marginLeft: 10, marginTop: 50 }}
            className="btn btn-ladda btn-primary"
            loading={loadingSave}
            onClick={createOnboardingPerson}
            data-style={EXPAND_RIGHT}
          >
            Create Person
          </LaddaButton>
        </Col>
      </Row>
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        title={modalConfirm.title}
        callback={modalConfirm.callback}
        saving={loadingSave}
      />

      <ModalComments
        {...modalComments}
        id={modalComments.personId}
        person={modalComments.person}
        account={false}
        toggle={toggleModalComments}
        services={services}
        setRedirectPerson={setRedirectPerson}
      />
    </div>
  );
};

FinalizeTab.propTypes = {
  accountId: PropTypes.string.isRequired,
  setAccountData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  mode: PropTypes.object.isRequired,
};

FinalizeTab.defaultProps = {
  Finalize: undefined,
};

export default FinalizeTab;
